import { queryOptions } from '@tanstack/react-query'
import { postRequest, IDENTITY_PREFIX } from 'global/helpers/requests'
import type { RequestAccountFormValues } from './Weblink.types'

interface WeblinkTokenResponse {
  token: string
}

export const WEBLINK_TOKEN_QUERY_KEY = 'weblink-token'

export const getWeblinkToken = async (token: string): Promise<WeblinkTokenResponse> =>
  await postRequest<WeblinkTokenResponse>('wl', { body: { token } }, IDENTITY_PREFIX)

export const weblinkTokenQueryOptions = (jwt: string) => queryOptions({
  queryKey: [WEBLINK_TOKEN_QUERY_KEY, jwt],
  queryFn: () => getWeblinkToken(jwt),
})

export const requestAccountInWeblink = async (data: RequestAccountFormValues, token: string): Promise<void> =>
  await postRequest<void>('signup', { body: data, token }, IDENTITY_PREFIX)
